<script setup>
import { BFormGroup } from 'bootstrap-vue-next';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

defineProps({
  availableProjects: {
    type: Array,
    required: true,
  },
});

const selectedProjects = defineModel('selectedProjects', {
  type: Array,
  required: true,
});
</script>

<template>
  <BFormGroup
    label="Projects"
    class="mb-3"
  >
    <VueSelect
      v-model="selectedProjects"
      multiple
      deselect-from-dropdown
      :close-on-select="false"
      :options="availableProjects"
      placeholder="Add a project by name, for example gitlab-runner"
    >
      <template #no-options="{ search, searching }">
        <span v-if="searching && search">
          No issues found for project "{{ search }}"
        </span>
        <span v-else>
          No projects available
        </span>
      </template>
    </VueSelect>
  </BFormGroup>
</template>
